
export default {
  name: 'ComponentLanguageSwitch',
  components: {},
  props: {
    white: {
      type: Boolean,
      require: false,
      default: false
    },
    isNavbarItem: {
      type: Boolean,
      require: false,
      default: false
    }
  },
  data: () => ({
    translationRoutes: null
  }),
  computed: {
    language() {
      return this.$store.getters.language
    },
    possibleLanguages() {
      return this.$store.getters.possibleLanguages
    },
    languagePaths() {
      return this.$store.getters.languagePaths
    }
  },
  watch: {
    $route() {
      setTimeout(() => {
        this.setTranslationRoutes()
      }, 150)
    }
  },
  updated() {},
  created() {},
  async mounted() {
    // if (!this.$store.getters.languagePaths) {
    //   this.$store.dispatch('getLanguagePaths').then(() => {
    //     this.setTranslationRoutes()
    //   })
    // } else {
    this.setTranslationRoutes()
    // }
  },
  methods: {
    async setTranslationRoutes() {
      if (!this.language || !this.languagePaths) {
        this.translationRoutes = null
        return null
      }
      let languagePathsCopy = JSON.parse(JSON.stringify(this.languagePaths))
      let filteredLanguageObject = languagePathsCopy.filter((item) => {
        return (
          item[this.language] &&
          item[this.language].path == window.location.pathname
        )
      })
      this.translationRoutes =
        filteredLanguageObject.length > 0 ? filteredLanguageObject[0] : null

      if (window && window.UC_UI) {
        if (
          window.UC_UI.getActiveLanguage().toLowerCase() !==
          this.language.toLowerCase()
        ) {
          const settings = UC_UI.getSettingsCore()
          if (
            settings.language.available.includes(this.language.toLowerCase())
          ) {
            await window.UC_UI.updateLanguage(this.language.toLowerCase())
          } else {
            console.error(
              `Language "${this.language.toLowerCase()}" is not Available`
            )
          }
        }
        await window.UC_UI.restartEmbeddings()
      }
    },
    async switchLanguage(newRouteObject) {
      this.$store.commit('setLanguage', { language: newRouteObject.language })
      this.pushMetaEvent(true)
      this.$router.push({
        path: newRouteObject.path
      })
      if (this.$route.path == newRouteObject.path) {
        await this.$nuxt.refresh()
      }
    }
  }
}
